import api from './api';
import {
    Response,
    UpdateRecipient,
} from '../dtos';

const updateRecipient = async (dto: UpdateRecipient): Promise<UpdateRecipient> => {
    const { data } = await api.put<Response<UpdateRecipient>>(`recipient/${dto.id}`, dto);
    return data.data;
};

export { updateRecipient };